<div class="mb-3">
  @if (labelDescription) {
  <label for="formFile" class="form-label">{{ labelDescription }}</label>
  }
  <ng-container *ngTemplateOutlet="fileName ? hasFile : noFile"></ng-container>
  <ng-template #noFile>
    <div
      [ngClass]="
        displayAsButton
          ? 'card border-1 p-2 file-upload-container noFile'
          : 'input-group'
      "
      class="w-100 bg-white">
      <input
        type="file"
        (change)="fileUpload($event)"
        [formControl]="fileControl"
        [id]="inputId"
        [accept]="allowedFileTypes ? allowedFileTypes.join(',') : ''"
        [placeholder]="placeholder"
        [ngClass]="
          displayAsButton ? 'uploader file-upload-input' : 'form-control'
        "
        class="" />
      @if (displayAsButton) {
      <label [for]="inputId" class="modal-title-icon-primary icon-border-light">
        <i class="fa fa-cloud-upload"></i>
      </label>
      } @if (displayAsButton) {
      <div
        class="uploader-container d-flex flex-row gap-1 align-items-baseline">
        <label [for]="inputId" class="btn btn-link p-0">{{
          'Click to upload' | translate
        }}</label>
        <p class="p-0 m-0">{{ 'Or drag and drop it here' | translate }}</p>
      </div>
      }
    </div>
  </ng-template>
  <ng-template #hasFile>
    <div class="file-upload-container card border-1 p-2">
      <div class="d-flex justify-content-start align-items-center gap-2">
        <div class="modal-title-icon-primary icon-border-light">
          <i class="fa-regular fa-file"></i>
        </div>
        <div class="file-info w-100 d-flex justify-content-between">
          <div class="filename">
            <p class="py-0 my-0">{{ fileName }}</p>
            @if (fileSize) {
            <p class="py-0 my-0 fs-6">
              {{ fileSize }}
            </p>
            }
          </div>
          <div class="delete-icon">
            <button type="button" class="btn p-0" (click)="resetFileInput()">
              <i
                class="fa-regular fa-trash-alt text-muted"
                aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  @if ( (getFileControlErrorMessage() && fileControl.touched) ||
  fileControl.dirty ) {
  <div
    [innerHTML]="getFileControlErrorMessage()"
    class="form-error w-100 small text-danger"></div>
  }
</div>
